<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-title>Informasi Laporan</v-card-title>
      <v-card-text>
        <v-list class="py-0">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Jadwal Laporan</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-calendar-month</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'jadwal') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>Periode Laporan Berlaku</b>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Sekolah</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-office-building-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(sekolah, 'sekolah.data.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>NPSN : </b>
                        {{ $getDeepObj(sekolah, 'sekolah.data.npsn') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'ptk.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>No. UKG/SIMPKB ID : </b>
                        {{ $getDeepObj(initValue, 'ptk.no_ukg') || $getDeepObj(initValue, 'ptk.ptk_id') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-3"></v-divider>
        <template v-if="kInstrumen === 'dasar'">
          <v-row>
            <v-col cols="12" md="7">
              <span class="font-weight-medium blue--text body-1" v-html="`Mekanisme Pembelajaran`"></span><br />
              <span class="grey--text" v-html="`Pilihlah Mekanisme Pembelajaran yang digunakan`"></span>
            </v-col>
            <v-col cols="12" md="5">
              <v-spacer></v-spacer>
              <div class="ml-auto">
                <div class="radio-outline">
                  <template v-for="item in mBelajar">
                    <span class="ml-md-1" :key="item.k_kp_opsi_psp">
                      <input
                        type="radio"
                        :id="`belajar_${item.k_kp_opsi_psp}`"
                        v-model="form['k_belajar_psp']"
                        :value="`${item.k_kp_opsi_psp}`"
                        :disabled="isPreview"
                        checked
                      />
                      <label :for="`belajar_${item.k_kp_opsi_psp}`">{{ item.keterangan }}</label>
                    </span>
                  </template>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
        </template>
        <div v-if="instruments[kInstrumen] && instruments[kInstrumen]['type'] === 'form'" class="black--text">
          <div class="mt-3 pa-5 container">
            <base-form-generator :schema="instruments[kInstrumen]['schema']" v-model="form" />
            <div class="mt-2" v-if="form.k_moda_pmo">
              <template v-if="Number(form.k_moda_pmo) === 1">
                <template v-for="(meeting, m) in form.data_meeting_pmo">
                  <v-row :key="m">
                    <v-col cols="12" :md="isPreview ? 10 : 9" sm="12">
                      <base-form-generator
                        :key="m"
                        :schema="instruments[kInstrumen]['meetings']"
                        v-model="form.data_meeting_pmo[m]"
                        @input="getDurasi(form.data_meeting_pmo[m], m)"
                      />
                    </v-col>
                    <v-col cols="12" :md="isPreview ? 2 : 3" sm="12">
                      <div class="mt-5">
                        <v-btn
                          v-if="!isPreview"
                          class="mt-n2"
                          color="error"
                          :disabled="m === 0 && (form.data_meeting_pmo || []).length === 1"
                          depressed
                          @click="onDelTautan(m)"
                        >
                          <v-icon left>mdi-delete</v-icon> Hapus
                        </v-btn>
                        <span class="blue--text pa-3">
                          {{ (durasis && durasis[Number(m)]) || '' }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <v-btn
                  v-if="!isPreview"
                  @click="onAddTautan"
                  color="secondary"
                  elevation="0"
                  class="my-3"
                  :disabled="form.data_meeting_pmo.length === 3"
                >
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah Tautan
                </v-btn>
              </template>
              <template>
                <div v-if="berkasPmo.length">
                  <template v-for="(berkas, id) of berkasPmo">
                    <v-row class="pa-0" :key="id">
                      <v-col cols="12" sm="12" md="5">
                        <span :class="[`px-0 body-2 info--text`]">
                          Judul foto dokumentasi kegiatan ke-{{ id + 1 }}
                        </span>
                        <v-text-field :value="berkas.judul" outlined single-line dense disabled hide-details />
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="mt-6">
                          <v-btn
                            color="success"
                            class="white--text mx-1"
                            elevation="0"
                            :disabled="!berkas.url_berkas"
                            :href="berkas.url_berkas"
                            target="_blank"
                          >
                            <v-icon left dark>
                              mdi-eye
                            </v-icon>
                            Lihat
                          </v-btn>
                          <v-btn
                            v-if="isPreview && berkas.is_reupload"
                            color="primary"
                            class="white--text mx-1"
                            elevation="0"
                            @click="onReuploadBerkas(berkas)"
                          >
                            <v-icon left dark>
                              mdi-upload
                            </v-icon>
                            Unggah
                          </v-btn>
                          <v-btn
                            v-if="!isPreview"
                            color="error"
                            class="white--text"
                            @click="onDelBerkas(berkas)"
                            elevation="0"
                          >
                            <v-icon left dark>
                              mdi-delete
                            </v-icon>
                            Hapus
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </div>
                <div v-else>
                  <v-row>
                    <v-col cols="12">
                      <div>
                        <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
                          Foto dokumentasi kegiatan
                        </span>
                      </div>
                      <div>
                        <span class="subtitle-1"
                          >Belum ada <strong>foto dokumentasi kegiatan</strong> yang diunggah</span
                        >
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <v-btn
                v-if="!isPreview"
                @click="onAddBerkas"
                color="secondary"
                elevation="0"
                class="mt-3"
                :disabled="berkasPmo.length === 5"
              >
                <v-icon left dark>
                  mdi-plus
                </v-icon>
                Tambah berkas
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else-if="instruments[kInstrumen]" class="black--text">
          <div class="mt-3 mb-7">
            <div>
              <span
                class="font-weight-medium blue--text"
                v-html="instruments[kInstrumen].label"
                style="font-size: 18px"
              ></span>
            </div>
            <span class="grey--text text--darken-1" v-html="instruments[kInstrumen].keterangan"></span>
          </div>
          <div>
            <template v-if="kInstrumen === 'dasar' && versi === 2">
              <v-row v-for="(child, c) in instruments[kInstrumen].items" :key="c">
                <template v-if="c === 0">
                  <v-col cols="12" class="pt-0">
                    <v-alert dense text type="info">
                      <h3 class="black--text">Instruksi Umum</h3>
                      <ol class="black--text mt-1" style="padding-inline-start: 20px">
                        <li>
                          Isilah pertanyaan berikut dengan menggabungkan hasil observasi yang Bapak/Ibu lakukan selama
                          pendampingan serta di saat coaching bersama Kepala Sekolah.
                        </li>
                        <li>
                          Pertanyaan tidak harus diisi penuh langsung dalam 1 bulan. Isilah sesuai dengan temuan yang
                          Bapak/Ibu dapatkan pada bulan tersebut.
                        </li>
                        <li>
                          Pada bulan ketiga setiap periode laporan, diharapkan Bapak/Ibu sudah selesai mengisi seluruh
                          pertanyaan. Jangan lupa klik <strong>“SIMPAN”</strong> setiap bulan saat sudah mengisi
                          pertanyaan.
                        </li>
                      </ol>
                    </v-alert>
                    <h2 class="secondary--text">A. Efektivitas Pembelajaran</h2>
                    <p class="text-justify grey--text text--darken-1 mt-1" style="font-size: 15px">
                      Pilihlah opsi berdasarkan hasil pendampingan yang Bapak/Ibu lakukan selama lokakarya, penguatan
                      komite pembelajaran, dan coaching. Pilih opsi yang paling sesuai dengan hasil amatan Bapak/Ibu
                      tehadap kondisi guru-guru anggota komite pembelajaran di sekolah yang Anda damping.
                    </p>
                  </v-col>
                </template>
                <template v-if="c === 11">
                  <v-col cols="12">
                    <h2 class="secondary--text">
                      B. Efektivitas kepemimpinan Kepala Sekolah sebagai Pemimpin Pembelajaran di Sekolah
                    </h2>
                    <p class="text-justify grey--text text--darken-1 mt-1" style="font-size: 15px">
                      Pilihlah opsi berdasarkan hasil pendampingan yang Bapak/Ibu lakukan selama lokakarya, penguatan
                      komite pembelajaran, dan coaching. Pilih opsi yang paling sesuai dengan hasil amatan Bapak/Ibu
                      tehadap perilaku Kepala Sekolah di satuan pendidikan dampingan Anda.
                    </p>
                  </v-col>
                </template>
                <v-col cols="12" class="py-0">
                  <div class="subtitle-1 font-weight-medium">
                    <span v-if="[40, 50].includes(+child.k_kp_instrumen_psp)"></span>
                    <span v-else-if="+child.k_kp_instrumen_psp < 40">{{ c + 1 }}. {{ child.keterangan }}</span>
                    <span v-else>{{ c }}. {{ child.keterangan }}</span>
                  </div>
                  <template v-if="[40, 50].includes(+child.k_kp_instrumen_psp)">
                    <v-textarea
                      v-model="form['deskripsi'][child.k_kp_instrumen_psp]"
                      placeholder="Masukkan deskripsi Anda..."
                      hint="Maksimal 500 karakter"
                      persistent-hint
                      dense
                      outlined
                      counter="500"
                      class="ml-5"
                      :readonly="isPreview"
                      style="max-width: 98%"
                      @keydown="$emit('autosave')"
                    >
                    </v-textarea>
                  </template>
                  <template v-else>
                    <v-radio-group
                      v-model="form['jawaban'][child.k_kp_instrumen_psp]"
                      hide-details
                      class="ml-4 mt-0 pt-0 body-2"
                    >
                      <v-radio
                        v-for="(opt, s) in pilihan"
                        :key="`${c}_${s}`"
                        :label="opt.label"
                        :value="opt.value"
                        :disabled="isPreview"
                        class="mb-1"
                      />
                    </v-radio-group>
                  </template>
                  <v-divider class="my-5 mb-7" />
                </v-col>
              </v-row>
            </template>
            <template v-if="['rencana', 'pelaksanaan', 'efektivitas'].includes(kInstrumen)">
              <v-row v-for="(child, c) in instruments[kInstrumen].items" :key="c">
                <v-col cols="12" class="py-0">
                  <div class="subtitle-1 font-weight-medium">
                    <span>{{ c + 1 }}. {{ child.keterangan }}</span>
                  </div>
                  <template v-if="[86, 95, 103].includes(+child.k_kp_instrumen_psp)">
                    <v-textarea
                      v-model="form['deskripsi'][child.k_kp_instrumen_psp]"
                      placeholder="Masukkan deskripsi Anda..."
                      hint="Maksimal 500 karakter"
                      persistent-hint
                      dense
                      outlined
                      counter="500"
                      class="ml-5"
                      :readonly="isPreview"
                      style="max-width: 98%"
                      rows="4"
                      auto-grow
                      @keydown="$emit('autosave')"
                    >
                    </v-textarea>
                  </template>
                  <template v-else>
                    <v-radio-group class="mt-0 ml-4" v-model="form['jawaban'][child.k_kp_instrumen_psp]">
                      <v-radio
                        v-for="(opt, s) in pilihan[child.k_kp_instrumen_psp]"
                        :value="opt.value"
                        :key="`${c}_${s}`"
                        :disabled="isPreview"
                        class="mb-1"
                        :ripple="false"
                        style="align-items: unset"
                      >
                        <template v-slot:label>
                          <p class="black--text text-justify body-2 mb-0">
                            <span class="orange--text font-weight-medium" v-html="opt.label"></span>
                            <br />
                            <span v-html="opt.deskripsi"></span>
                          </p>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </template>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row v-for="(child, c) in instruments[kInstrumen].items" :key="c">
                <v-col cols="12" v-if="c !== 0">
                  <v-divider />
                </v-col>
                <v-col cols="12" md="7" sm="12" class="my-auto pt-0 body-2">
                  <v-row no-gutters>
                    <v-col cols="1" style="min-width: 15px; max-width: 25px" class="flex-shrink-1">
                      {{ c + 1 }}.
                    </v-col>
                    <v-col cols="11" class="flex-grow-1">
                      {{ child.keterangan }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="5" sm="12" class="my-auto pt-0 text-right">
                  <div class="radio-outline">
                    <template v-for="(opt, s) in pilihan">
                      <span class="ml-md-1" :key="s">
                        <input
                          type="radio"
                          :id="`${c}_${s}`"
                          v-model="form['jawaban'][child.k_kp_instrumen_psp]"
                          :value="opt.value"
                          :disabled="isPreview || isEditSaran"
                          checked
                        />
                        <label :for="`${c}_${s}`">{{ opt.label }}</label>
                      </span>
                    </template>
                  </div>
                </v-col>
                <v-col
                  v-if="kInstrumen && kInstrumen !== 'dasar' && Number(form['jawaban'][child.k_kp_instrumen_psp]) === 1"
                  cols="12"
                  md="12"
                  sm="12"
                >
                  <v-expansion-panels flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="px-0">
                        <template v-slot:default="{ open }">
                          <div>
                            <v-toolbar flat>
                              <v-toolbar-title class="body-1 ml-n4">
                                <v-avatar size="30">
                                  <v-icon dark color="warning">mdi-information</v-icon>
                                </v-avatar>
                                <span class="font-weight-medium">Lengkapi semua informasi berikut</span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <span class="text-right blue--text">
                                {{ open ? 'Tutup Detail' : 'Lihat Detail' }}
                              </span>
                            </v-toolbar>
                          </div>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="mt-2">
                          <validation-provider name="Deskripsi Hambatan" rules="maxChar: 500" v-slot="{ errors }">
                            <v-textarea
                              v-model="form['deskripsi'][child.k_kp_instrumen_psp]"
                              label="Deskripsi Hambatan"
                              hint="Maksimal 500 karakter"
                              persistent-hint
                              dense
                              outlined
                              counter="500"
                              :readonly="isPreview || isEditSaran"
                              @keydown="$emit('autosave')"
                              :error-messages="errors"
                            >
                            </v-textarea>
                          </validation-provider>
                          <validation-provider name="Saran" rules="maxChar: 500" v-slot="{ errors }">
                            <v-textarea
                              v-model="form['saran'][child.k_kp_instrumen_psp]"
                              label="Saran / Solusi"
                              hint="Maksimal 500 karakter"
                              persistent-hint
                              dense
                              outlined
                              counter="500"
                              class="mt-2"
                              :readonly="isPreview"
                              @keydown="$emit('autosave')"
                              :error-messages="errors"
                            ></v-textarea>
                          </validation-provider>
                          <v-row>
                            <v-col v-if="false" cols="12" md="7" sm="12">
                              <div>PIC <i>(Person in Charge)</i></div>
                              <template v-if="isPreview">
                                {{ $getDeepObj(form, `k_pic_psp.${child.k_kp_instrumen_psp}`) || 'belum dipilih' }}
                              </template>
                              <template v-else>
                                <v-radio-group v-model="form['k_pic_psp'][child.k_kp_instrumen_psp]" row>
                                  <v-radio
                                    v-for="(radio, r) in masters.pic || []"
                                    :key="r"
                                    :label="radio.keterangan"
                                    :value="radio.k_kp_opsi_psp"
                                    :readonly="isPreview"
                                  ></v-radio>
                                </v-radio-group>
                              </template>
                            </v-col>
                            <v-col cols="12" md="12" sm="12">
                              <div class="subtitle-1">Status</div>
                              <span class="grey--text">
                                Pastikan memilih salah satu status, pada hambatan yang disampaikan. Sesuai dengan
                                kondisi terbaru.
                              </span>
                              <div class="mt-3">
                                <v-btn
                                  :outlined="form['k_progres_psp'][child.k_kp_instrumen_psp] !== 32"
                                  color="orange"
                                  class="mx-md-1"
                                  small
                                  dark
                                  depressed
                                  @click="setOpsiPsp(child.k_kp_instrumen_psp, 32)"
                                >
                                  <v-icon left>mdi-help-circle</v-icon> Butuh Dukungan
                                </v-btn>
                                <v-btn
                                  :outlined="form['k_progres_psp'][child.k_kp_instrumen_psp] !== 30"
                                  color="primary"
                                  class="mx-md-1"
                                  small
                                  dark
                                  depressed
                                  @click="setOpsiPsp(child.k_kp_instrumen_psp, 30)"
                                >
                                  <v-icon left>mdi-circle-half-full</v-icon> Dalam Pengerjaaan
                                </v-btn>
                                <v-btn
                                  :outlined="form['k_progres_psp'][child.k_kp_instrumen_psp] !== 31"
                                  color="success"
                                  class="mx-md-1"
                                  small
                                  dark
                                  depressed
                                  @click="setOpsiPsp(child.k_kp_instrumen_psp, 31)"
                                >
                                  <v-icon left>mdi-checkbox-marked-circle</v-icon> Selesai
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                        <template v-if="(tanggapanPmo[child.k_kp_instrumen_psp] || []).length">
                          <template v-for="(tanggapan, idx) in tanggapanPmo[child.k_kp_instrumen_psp] || []">
                            <v-card flat :color="idx % 2 === 0 ? '#FFF4E9' : '#E8F2FF'" class="my-2 pa-3" :key="idx">
                              <div class="subtitle-1 font-weight-bold">
                                Tanggapan {{ $getDeepObj(tanggapan, 'instansi.data.nama') }}
                              </div>
                              <div class="mt-3">
                                <v-row dense no-gutters>
                                  <v-col>
                                    <v-chip
                                      dark
                                      small
                                      :color="
                                        WARNA_STATUS[tanggapan.k_progres_psp] &&
                                          WARNA_STATUS[tanggapan.k_progres_psp]['color']
                                      "
                                    >
                                      <v-icon small left>
                                        {{
                                          WARNA_STATUS[tanggapan.k_progres_psp] &&
                                            WARNA_STATUS[tanggapan.k_progres_psp]['icon']
                                        }}
                                      </v-icon>
                                      {{ $getDeepObj(tanggapan, 'm_kp_opsi_psp_progres_psp.data.keterangan') }}
                                    </v-chip>
                                  </v-col>
                                  <v-col class="text-right">
                                    {{ $localDate(tanggapan.updated_at) }}
                                  </v-col>
                                </v-row>
                                <v-alert
                                  class="my-2"
                                  prominent
                                  text
                                  border="left"
                                  :color="
                                    WARNA_STATUS[tanggapan.k_progres_psp] &&
                                      WARNA_STATUS[tanggapan.k_progres_psp]['color']
                                  "
                                >
                                  {{ tanggapan.catatan || '-' }}
                                </v-alert>
                                <a v-if="tanggapan.url_dokumen" :href="tanggapan.url_dokumen" target="_blank">
                                  <v-icon small left>
                                    mdi-file
                                  </v-icon>
                                  {{ tanggapan.url_judul || tanggapan.url_dokumen }}
                                </a>
                              </div>
                            </v-card>
                          </template>
                        </template>

                        <v-col cols="12" md="12" sm="12" v-if="(tanggapanPmo[child.k_kp_instrumen_psp] || []).length">
                          <div class="subtitle-1">Perkiraan Waktu Selesai</div>
                          {{
                            [36, 37].includes(
                              Math.max(...tanggapanPmo[child.k_kp_instrumen_psp].map((item) => item.k_progres_psp))
                            )
                              ? $localDate($getDeepObj(waktu[child.k_kp_instrumen_psp], 'tgl_rencana_pusat'))
                              : $localDate($getDeepObj(waktu[child.k_kp_instrumen_psp], 'tgl_rencana_daerah'))
                          }}
                        </v-col>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </template>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <berkas ref="berkas" :reupload="berkas.is_reupload" :jenis="jenis" :title="title" @upload="onAddBerkasSave" />
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import Berkas from '@views/gtk/lokakarya/components/Berkas';
import pilihanRencana from '../pilihan/rencana';
import pilihanPelaksanaan from '../pilihan/pelaksanaan';
import pilihanEfektivitas from '../pilihan/efektivitas';
import { mapActions } from 'vuex';
export default {
  props: {
    berkases: {
      type: Array,
      default: () => [],
    },
    initValue: {
      type: Object,
      default: null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    grup: {
      type: Object,
      default: () => {},
    },
    versi: {
      type: [Number, String],
      default: 1,
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    isEditSaran: {
      type: Boolean,
      default: false,
    },
  },
  components: { BaseFormGenerator, ValidationProvider, Berkas },
  data() {
    return {
      form: {},
      sekolah: {},
      kInstrumen: '',
      tanggapanPmo: {},
      waktu: {},
      berkas: {},
      jenis: '',
      title: '',
      WARNA_STATUS: {
        32: { color: 'orange', icon: 'mdi-check', catatanTeks: 'Catatan' },
        33: { color: 'primary', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        34: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk Fasilitator Pelapor' },
        35: { color: '#FF7F2A', icon: 'mdi-send', catatanTeks: 'Catatan untuk PMO Pusat' },
        36: { color: 'success', icon: 'mdi-check', catatanTeks: 'Saran/Solusi' },
        37: { color: '#FF4A4A', icon: 'mdi-close', catatanTeks: 'Catatan untuk PMO Dinas' },
      },
      durasis: [],
      pilihans: {
        rencana: pilihanRencana,
        pelaksanaan: pilihanPelaksanaan,
        efektivitas: pilihanEfektivitas,
      },
    };
  },
  computed: {
    instruments() {
      return {
        dasar: {
          label: 'Pertanyaan Dasar',
          keterangan: 'Isilah instrumen berikut berdasarkan informasi sebenarnya',
          items: (this.grup && this.grup['dasar']) || [],
        },
        rencana: {
          label: 'Tahapan Perencanaan IKM di Satuan Pendidikan',
          keterangan:
            'Pilihlah opsi berdasarkan hasil pendampingan yang Bapak/Ibu lakukan selama penugasan berlangsung. Pilih ' +
            'opsi yang paling sesuai dengan hasil amatan Bapak/Ibu terhadap kondisi implementasi kurikulum merdeka di ' +
            'satuan pendidikan dampingan Anda',
          items: (this.grup && this.grup['rencana']) || [],
        },
        pelaksanaan: {
          label: 'Tahapan Pelaksanaan IKM di Satuan Pendidikan',
          keterangan:
            'Pilihlah opsi berdasarkan hasil pendampingan yang Bapak/Ibu lakukan selama penugasa berlangsung. Pilih ' +
            'opsi yang paling sesuai dengan hasil amatan Bapak/Ibu terhadap kondisi implementasi kurikulum merdeka di ' +
            'satuan pendidikan dampingan Anda',
          items: (this.grup && this.grup['pelaksanaan']) || [],
        },
        efektivitas: {
          label: 'Efektivitas kepemimpinan Kepala Sekolah sebagai Pemimpin Pembelajaran di Sekolah',
          keterangan:
            'Pilihlah opsi berdasarkan hasil pendampingan yang Bapak/Ibu lakukan selama penugasan berlangsung. Pilih ' +
            'opsi yang paling sesuai dengan hasil amatan Bapak/Ibu terhadap kondisi implementasi kurikulum merdeka di ' +
            'satuan pendidikan dampingan Anda',
          items: (this.grup && this.grup['efektivitas']) || [],
        },
        sdm: {
          label: 'A. Sumber Daya Manusia (SDM)',
          keterangan:
            '(misalnya : keterbatasan jumlah PTK, kompetensi kepala dan guru, motivasi rendah, gagap teknologi)',
          items: (this.grup && this.grup['sdm']) || [],
        },
        anggaran: {
          label: 'B. Anggaran',
          keterangan: '(misalnya : Keterbatasan anggaran untuk menjalankan program di satuan pendidikan)',
          items: (this.grup && this.grup['anggaran']) || [],
        },
        teknologi: {
          label: 'C. Teknologi',
          keterangan: '',
          items: (this.grup && this.grup['teknologi']) || [],
        },
        pembelajaran: {
          label: 'D. Kegiatan Pembelajaran',
          keterangan: '',
          items: (this.grup && this.grup['pembelajaran']) || [],
        },
        pemda: {
          label: 'E. Dukungan Pemerintah Daerah',
          keterangan: '',
          items: (this.grup && this.grup['pemda']) || [],
        },
        internal: {
          label: 'F. Dukungan Internal Sekolah',
          keterangan: '',
          items: (this.grup && this.grup['internal']) || [],
        },
        mendesak: {
          label: 'G. Kondisi Mendesak',
          keterangan: '',
          items: (this.grup && this.grup['mendesak']) || [],
        },
        lain: {
          label: 'H. Lainnya',
          keterangan: '',
          items: (this.grup && this.grup['lain']) || [],
        },
        info: {
          label: 'Informasi Dasar',
          keterangan: '',
          type: 'form',
          items: [],
          schema: [
            {
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan_pmo',
              label: 'Tanggal Waktu Pelaksanaan',
              labelColor: 'secondary',
              hint: '',
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
              usePrependInnerIcon: 'mdi-calendar-month',
            },
            {
              type: 'VTextField',
              name: 'jml_peserta_pmo',
              label: 'Jumlah Peserta Yang hadir',
              labelColor: 'secondary',
              hint: '',
              mask: '####',
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
            },
            {
              type: 'VSelect',
              name: 'k_moda_pmo',
              label: 'Moda yang diterapkan',
              subHint:
                '*Jika pelaksanaan kegiatannya daring. Maka wajib inputkan link vicon dan bisa unggah foto kegiatannya. Sedangkan jika pelaksanaannya luring. Wajib unggah foto kegiatannya saja.',
              labelColor: 'secondary',
              hint: '',
              items: this.$mapForMaster(this.masters.lokakarya_moda_psp),
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
            },
          ],
          meetings: [
            {
              type: 'VTextField',
              name: 'nama',
              label: 'Judul Link Pertemuan Daring',
              labelColor: 'secondary',
              hint: '',
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
            },
            {
              type: 'VTextField',
              name: 'url_meeting',
              label: 'Link Video Reference',
              labelColor: 'secondary',
              hint: '',
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
              prependInnerIcon: 'mdi-video',
            },
          ],
        },
      };
    },
    mBelajar() {
      return (this.masters && this.masters.belajar) || [];
    },
    berkasPmo() {
      const berkas = this.berkases || [];
      return berkas.filter((s) => s.jenis === 'foto-pmo') || {};
    },
    pilihan() {
      if (this.versi === 3) {
        if (this.pilihans[this.kInstrumen]) {
          return this.pilihans[this.kInstrumen];
        }

        return [
          { label: 'Ya', value: 1 },
          { label: 'Tidak', value: 0 },
          { label: 'Data Belum Tersedia', value: 99 },
        ];
      }

      if (this.versi === 2) {
        if (this.kInstrumen === 'dasar') {
          return [
            { label: 'Belum diterapkan', value: 1 },
            { label: 'Sebagian besar belum diterapkan', value: 2 },
            { label: 'Sudah mulai diterapkan namun sangat bergantung pada bantuan/ dukungan', value: 3 },
            { label: 'Sebagian besar sudah diterapkan dengan bantuan minimal', value: 4 },
            { label: 'Semua sudah diterapkan secara mandiri (tanpa bantuan/ dukungan)', value: 5 },
            { label: 'Data Belum Tersedia', value: 99 },
          ];
        }

        return [
          { label: 'Ya', value: 1 },
          { label: 'Tidak', value: 0 },
          { label: 'Data Belum Tersedia', value: 99 },
        ];
      }

      return [
        { label: 'Ya', value: 1 },
        { label: 'Belum', value: 0 },
      ];
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('diklatPa', ['uploadBerkas', 'action']),

    reset() {
      this.form = {
        jawaban: {},
        k_progres_psp: {},
        deskripsi: {},
        saran: {},
        tanggapanPmo: {},
        k_belajar_psp: null,
        data_meeting_pmo: [
          {
            nama: '',
            url_meeting: '',
          },
        ],
      };
      this.durasis = [];
    },

    initForm(value) {
      if (!value) return;
      const { sekolah, formulir } = value;
      this.kInstrumen = value && value.grup;
      this.sekolah = sekolah;

      // set form
      this.$set(this.form, 'k_belajar_psp', formulir && formulir.k_belajar_psp ? `${formulir.k_belajar_psp}` : null);

      const keys = ['jawaban', 'k_progres_psp', 'deskripsi', 'saran'];
      const dataInstruments = this.$getDeepObj(formulir, 'psp_kp_pa_sekolah_instrumens.data') || [];
      const instruments = this.$arrToObj(dataInstruments, 'k_kp_instrumen_psp');

      if (this.instruments && this.instruments[this.kInstrumen] && this.instruments[this.kInstrumen]['items']) {
        for (const item of this.instruments[this.kInstrumen]['items']) {
          keys.forEach((key) => {
            const jawaban =
              instruments && instruments[item.k_kp_instrumen_psp] && instruments[item.k_kp_instrumen_psp][key];
            this.$set(
              this.form[key],
              item.k_kp_instrumen_psp,
              key === 'jawaban'
                ? jawaban === null || jawaban === undefined || isNaN(Number(jawaban))
                  ? ''
                  : Number(
                      instruments && instruments[item.k_kp_instrumen_psp] && instruments[item.k_kp_instrumen_psp][key]
                    )
                : key === 'k_progres_psp'
                ? Number(this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`)) > 32
                  ? 30
                  : this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`)
                : this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.${key}`) || ''
            );
          });

          // check apakah memeiliki tanggapan dari pmo
          this.$set(
            this.tanggapanPmo,
            item.k_kp_instrumen_psp,
            this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.psp_kp_pa_sekolah_instrumen_pmos.data`) || []
          );

          // tanggal rencana daerah dan pusat
          this.$set(this.waktu, item.k_kp_instrumen_psp, {
            tgl_rencana_daerah: this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.tgl_rencana_daerah`) || '',
            tgl_rencana_pusat: this.$getDeepObj(instruments, `${item.k_kp_instrumen_psp}.tgl_rencana_pusat`) || '',
          });
        }
      }
      if (this.kInstrumen === 'info') {
        const keys = ['tgl_pelaksanaan_pmo', 'jml_peserta_pmo', 'k_moda_pmo'];
        const meeting = this.$getDeepObj(formulir, 'data_meeting_pmo') || [];
        keys.forEach((key) => {
          this.$set(this.form, key, this.$getDeepObj(formulir, key));
        });

        if (meeting.length > 0) {
          this.$set(this.form, 'data_meeting_pmo', []);
          let formMeeting = [];

          meeting.forEach((item, index) => {
            formMeeting.push(item);
            this.durasis[index] = this.$durasiWaktu(this.$getDeepObj(item, 'durasi')) || null;
          });

          this.$set(this.form, 'data_meeting_pmo', formMeeting);
        }
      }
    },

    setOpsiPsp(index, value) {
      if (this.isPreview || this.isEditSaran) return;
      this.$set(this.form.k_progres_psp, index, value);
    },

    getValue() {
      const jawaban = (this.form && this.form['jawaban']) || {};
      const keys = ['k_progres_psp', 'deskripsi', 'saran'];
      let dasar = ['tgl_pelaksanaan_pmo', 'jml_peserta_pmo', 'k_moda_pmo'];
      let form = [];

      if (this.kInstrumen === 'info') {
        if (Number(this.$getDeepObj(this.form, 'k_moda_pmo')) === 1) dasar.push('data_meeting_pmo');
        dasar.forEach((key) => {
          this.$set(form, key, this.form[key]);
        });
      } else {
        Object.keys(jawaban).forEach((key) => {
          let obj = { k_kp_instrumen_psp: key, jawaban: [40, 50, 86, 95, 103].includes(+key) ? 1 : jawaban[key] };
          if (Number(obj && obj.jawaban) === 1) {
            keys.forEach((ins) => {
              this.$set(obj, ins, this.$getDeepObj(this.form, `${ins}.${key}`) || '');
            });
          }
          form.push(obj);
        });
      }

      return {
        grup: this.kInstrumen,
        form: form,
        k_belajar_psp: this.form && this.form.k_belajar_psp ? Number(this.form && this.form.k_belajar_psp) : null,
        dasar_ke: this.initValue.dasarKe,
      };
    },

    onAddBerkas() {
      if (this.isPreview) return;

      this.jenis = 'foto-pmo';
      this.title = 'Foto Kegiatan';
      this.berkas = {};

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddTautan() {
      this.form.data_meeting_pmo.push({ nama: '', url_meeting: '' });
    },

    onAddBerkasSave(berkas) {
      if (this.$isObject(this.berkas)) {
        this.onReuploadBerkasSave(berkas);
        return;
      }

      const pendampingId = this.$getDeepObj(this.initValue, 'pendampinganId');
      const sekolahId = this.$getDeepObj(this.initValue, 'sekolah.psp_kp_pa_sekolah_id');
      const formData = new FormData();

      formData.append('jenis', this.jenis);
      formData.append('judul', berkas.judul);
      formData.append('file', berkas.file);

      if (this.initValue.dasarKe) {
        formData.append('dasar_ke', this.initValue.dasarKe);
      }

      this.$refs.berkas.startLoading();
      this.uploadBerkas({
        pendampingId,
        sekolahId,
        params: formData,
        tipe: 'pmo',
      })
        .then(() => {
          this.$emit('refresh', {
            psp_kp_pa_pendampingan_id: pendampingId,
            psp_kp_pa_sekolah_id: sekolahId,
            dasarKe: this.initValue.dasarKe,
          });
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      const pendampingId = this.$getDeepObj(this.initValue, 'pendampinganId');
      const sekolahId = this.$getDeepObj(this.initValue, 'sekolah.psp_kp_pa_sekolah_id');
      const id = berkas.psp_kp_pa_sekolah_laporan_berkas_id || '';
      const dasarKe = berkas.dasar_ke || '';
      const params = { dasar_ke: dasarKe };

      this.$confirm('Anda yakin ingin menghapus berkas ?', 'Hapus berkas', {
        tipe: 'error',
      }).then(() => {
        this.action({ pendampingId, tipe: 'pmo', sekolahId, id, action: 'delete', params }).then(() => {
          this.$emit('refresh', { psp_kp_pa_pendampingan_id: pendampingId, psp_kp_pa_sekolah_id: sekolahId, dasarKe });
        });
      });
    },

    onDelTautan(index) {
      this.form.data_meeting_pmo.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    validate() {
      return true;
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },

    onReuploadBerkas(berkas) {
      this.jenis = 'foto-pmo';
      this.title = 'Foto Kegiatan';
      this.berkas = berkas;

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onReuploadBerkasSave(berkas) {
      const pendampingId = this.$getDeepObj(this.initValue, 'pendampinganId');
      const sekolahId = this.$getDeepObj(this.initValue, 'sekolah.psp_kp_pa_sekolah_id');
      const berkasId = this.berkas.psp_kp_pa_sekolah_laporan_berkas_id || '';
      const formData = new FormData();

      formData.append('jenis', this.jenis);
      formData.append('judul', berkas.judul);
      formData.append('file', berkas.file);

      if (this.initValue.dasarKe) {
        formData.append('dasar_ke', this.initValue.dasarKe);
      }

      this.$refs.berkas.startLoading();
      this.uploadBerkas({
        pendampingId,
        sekolahId,
        berkasId,
        params: formData,
        tipe: 'pmo',
      })
        .then(() => {
          this.$emit('refresh', {
            psp_kp_pa_pendampingan_id: pendampingId,
            psp_kp_pa_sekolah_id: sekolahId,
            dasarKe: this.initValue.dasarKe,
          });
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
